"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailCompartilhar = void 0;
var react_1 = __importStar(require("react"));
var InputEmail_1 = require("../../Inputs/InputEmail/InputEmail");
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Cores_1 = require("../../Cores/Cores");
var Botao_1 = require("../../Botao/Botao");
var Icone_1 = require("../../Icone/Icone");
var Chip_1 = require("../../Chip/Chip");
var globalMu_1 = __importDefault(require("../../../globalMu"));
var InputTextArea_1 = require("../../Inputs/InputTextArea/InputTextArea");
var __1 = require("../../..");
var estiloEmail = require("./EmailCompartilhar.module.scss");
//region Corpo Email
var EmailCompartilhar = function (_a) {
    var listaEmails = _a.listaEmails, valor = _a.valor, corpoMensagem = _a.corpoMensagem, conteudoAjudaEmail = _a.conteudoAjudaEmail, quantidadeMaximaEmails = _a.quantidadeMaximaEmails, onChangeEmail = _a.onChangeEmail, onChangeMensagem = _a.onChangeMensagem, onAddEmail = _a.onAddEmail, onRemoveEmail = _a.onRemoveEmail, onSelectEmail = _a.onSelectEmail;
    var _b = (0, react_1.useState)(conteudoAjudaEmail || undefined), ajudaEmail = _b[0], setAjudaEmail = _b[1];
    //#region Email
    var renderEmail = (react_1.default.createElement("div", { className: estiloEmail.campoEmail },
        react_1.default.createElement(InputEmail_1.InputEmail, { tamanho: "small", id: "email", label: false, placeholder: "Inserir E-mail", valor: valor, conteudoAjuda: ajudaEmail, onChange: onChangeEmail, variante: ajudaEmail === null || ajudaEmail === void 0 ? void 0 : ajudaEmail.estado, onKeyDown: function (event) {
                if (event.key === "Enter" || event.key === "NumpadEnter") {
                    onAddEmail && onAddEmail();
                }
            } }),
        quantidadeMaximaEmails && listaEmails && listaEmails.length < quantidadeMaximaEmails ? (react_1.default.createElement(Botao_1.Botao, { tamanho: "xsmall", exibirBotaoArrendondado: true, style: { padding: ".5rem", cursor: "pointer" }, estilo: "outlined", onClick: globalMu_1.default.validateEmail(valor)
                ? onAddEmail
                : function () {
                    return setAjudaEmail({
                        estado: "error",
                        texto: "Insira um telefone válido.",
                        icone: "warning",
                    });
                } },
            react_1.default.createElement(Icone_1.Icone, { nome: "person_add", altura: "20px", largura: "20px", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }))) : (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center', height: '100%' } },
            react_1.default.createElement(__1.Tooltip, { estiloTooltip: "warning", mostrarDivider: false, descricaoTooltip: "Quantidade M\u00E1xima de Emails Atingida." },
                react_1.default.createElement(Icone_1.Icone, { nome: "info", altura: "20px", largura: "20px", cor: Cores_1.Cores.MensagensDoSistema.AmareloMU }))))));
    //#region Chips
    var renderChips = (react_1.default.createElement("div", { className: estiloEmail.chips },
        listaEmails.length > 0 && (react_1.default.createElement("div", { className: estiloEmail.chipGrupo },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Principal", style: { marginBottom: 4 } }),
            react_1.default.createElement(Chip_1.Chip, { key: "ChipEmail[0]", botaoFechar: true, estilo: "primary_dark", onClose: function () { return onRemoveEmail && onRemoveEmail(listaEmails[0]); }, onClick: function () { return onSelectEmail && onSelectEmail(listaEmails[0]); }, titulo: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Icone_1.Icone, { nome: "person", altura: "20px", largura: "20px", cor: Cores_1.Cores.GradacaoNeutros.BrancoMU50 }),
                    react_1.default.createElement("p", { className: estiloEmail.chipText, title: listaEmails[0], onClick: function () { } }, listaEmails[0].length > 30
                        ? listaEmails[0].substring(0, 30) + "..."
                        : listaEmails[0])), style: {
                    width: "fit-content",
                    alignItems: "center",
                    cursor: "pointer",
                }, estado: true }))),
        listaEmails.length > 1 && (react_1.default.createElement("div", { className: estiloEmail.chipGrupo },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "C\u00F3pias", style: { margin: "8px 0 4px 0" } }),
            listaEmails.slice(1).map(function (email, index) { return (react_1.default.createElement(Chip_1.Chip, { key: "ChipEmail[".concat(index + 1, "]"), botaoFechar: true, onClose: function () { return onRemoveEmail && onRemoveEmail(email); }, onClick: function () { return onSelectEmail && onSelectEmail(email); }, titulo: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Icone_1.Icone, { nome: "content_copy", altura: "20px", largura: "20px", cor: Cores_1.Cores.GradacaoNeutros.BrancoMU50 }),
                    react_1.default.createElement("p", { className: estiloEmail.chipText, title: email, onClick: function () { } }, email.length > 30
                        ? email.substring(0, 30) + "..."
                        : email)), style: {
                    width: "fit-content",
                    alignItems: "center",
                    cursor: "pointer",
                }, estado: true })); })))));
    //#region Header
    var renderHeader = (react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Para" }));
    //#region Mensagem
    var renderMensagem = (react_1.default.createElement("div", { className: estiloEmail.secaoMensagem },
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "caption", negrito: 400, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, conteudo: "Mensagem" }),
        react_1.default.createElement(InputTextArea_1.InputTextArea, { label: false, placeholder: "Inserir Mensagem", valor: corpoMensagem, onChange: onChangeMensagem })));
    (0, react_1.useEffect)(function () {
        setAjudaEmail(conteudoAjudaEmail);
    }, [conteudoAjudaEmail]);
    //#region Render
    return (react_1.default.createElement("div", { className: estiloEmail.container },
        react_1.default.createElement("div", { className: estiloEmail.listaEmails },
            renderHeader,
            renderEmail,
            renderChips),
        react_1.default.createElement("div", null,
            react_1.default.createElement(__1.Divider, { orientacao: "vertical" })),
        react_1.default.createElement("div", { style: { display: "flex", gap: "24px", width: "50%" } }, renderMensagem)));
};
exports.EmailCompartilhar = EmailCompartilhar;
